import { DATA_ATTR, CLASSES, EVENTS } from '../config/constants';

export default class HamburgerMenu {
  constructor(toggleEl) {
    this.toggleEl = toggleEl;
    this.navEl = null;
  }

  init() {
    if (!this.toggleEl) {
      return;
    }

    const hasToggleTarget = this.getToggleTarget();
    if (!hasToggleTarget) {
      return;
    }

    this.watchHamburger();
  }

  getToggleTarget() {
    const selector = this.toggleEl.dataset[DATA_ATTR.HAMBURGER.TARGET];
    const element = document.querySelector(selector);

    if (!element) {
      return false;
    }

    this.navEl = element;

    return element;
  }

  watchHamburger() {
    this.toggleEl.addEventListener('click', this.toggleMenu.bind(this));
  }

  toggleMenu() {
    const isActive = this.toggleEl.classList.contains(CLASSES.ACTIVE);

    if (isActive) {
      this.hideMenu();
    } else {
      this.showMenu();
    }
  }

  hideMenu() {
    this.toggleClasses('remove');
    this.dispatchEvent(EVENTS.HAMBURGER.HIDE);
  }

  showMenu() {
    this.toggleClasses('add');
    this.dispatchEvent(EVENTS.HAMBURGER.SHOW);
  }

  toggleClasses(action) {
    this.toggleEl.classList[action](CLASSES.ACTIVE);
    this.navEl.classList[action](CLASSES.ACTIVE);
    document.querySelector('body').classList[action](CLASSES.HAMBURGER_ACTIVE);
  }

  dispatchEvent(event) {
    window.dispatchEvent(new Event(event, { bubbles: true }));
  }
}
